import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebsiteRoutingModule } from './website-routing.module';
//import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule,FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserModule } from '@angular/platform-browser';
//import { MaterialModule } from '@angular/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCard, MatCardActions, MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { RegisteruserasComponent } from './common/registeruseras/registeruseras.component'; 
import { RegisterComponent } from './MSME/register/register.component';
import { MSMEUSERVERIFICATIONComponent } from './MSME/msmeuserverification/msmeuserverification.component';
import { ContactdetailsComponent } from './MSME/contactdetails/contactdetails.component';
import { CredentialdetailsComponent } from './MSME/credentialdetails/credentialdetails.component';
import { MsmepreviewpageComponent } from './MSME/msmepreviewpage/msmepreviewpage.component';
import { PersonaldetailsComponent } from './MSME/personaldetails/personaldetails.component';
import { IAregisterComponent } from './IA/iaregister/iaregister.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component'
import { IapreviewpageComponent } from './IA/iapreviewpage/iapreviewpage.component';
import { IaproposalpageComponent } from './IA/iaproposalpage/iaproposalpage.component';
import { IasubmitnewproposalComponent } from './IA/iasubmitnewproposal/iasubmitnewproposal.component';
import { MssidcproposalpageComponent } from './MSSIDC/mssidcproposalpage/mssidcproposalpage.component';
import { MssidcverifyproposalComponent } from './MSSIDC/mssidcverifyproposal/mssidcverifyproposal.component';
import { VerifymsmeComponent } from './MSSIDC/Verify-MSME/verifymsme.component';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { VerifyMSMEDetailsComponent } from './MSSIDC/verify-msme-details/verify-msme-details.component';
import { VerifyMSMEViewComponent } from './MSSIDC/verify-msme-view/verify-msme-view.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IaprofileComponent } from './IA/iaprofile/iaprofile.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { OtheruserdetailsComponent } from './MSME/otheruserdetails/otheruserdetails.component';
import { CreatenewproposalComponent } from './IA/createnewproposal/createnewproposal.component';
import { IaeventcreateComponent } from './IA/iaeventcreate/iaeventcreate.component';
import { LayoutComponent } from './layout/layout.component';
import { LeftcolComponent } from './leftcol/leftcol.component';
import { DashboardComponent } from './MSME/dashboard/dashboard.component';
import { PaginationComponent } from '../../../shared/pagination/pagination.component';
import { ProposalComponent } from './IA/proposal/proposal.component';
import { ProfileComponent } from './MSME/profile/profile.component';
import { EnrollneweventComponent } from './MSME/enrollnewevent/enrollnewevent.component';
import { VieweventsComponent } from './MSME/viewevents/viewevents.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { IaquestionanswerComponent } from './IA/iaquestionanswer/iaquestionanswer.component';
import { FeedbackformComponent } from './MSME/feedbackform/feedbackform.component';
import { ViewflattedgalaComponent } from './MSME/viewflattedgala/viewflattedgala.component';
import { ViewgrievancesdashboardComponent } from './MSME/viewgrievancesdashboard/viewgrievancesdashboard.component';
import { VieweventdetailsComponent } from './MSME/vieweventdetails/vieweventdetails.component';
import { DownloadticketComponent } from './MSME/downloadticket/downloadticket.component';
import { VerifyProposalComponent } from './MSSIDC/verify-proposal/verify-proposal.component';
import { VerifyProposalDetailsComponent } from './MSSIDC/verify-proposal-details/verify-proposal-details.component';
import { MatTabsModule } from '@angular/material/tabs';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TrimInputValueDirective } from '../../../shared/directive/trim-input-value.directive';
import { VieweventComponent } from './IA/viewevent/viewevent.component';
import { EventdetailComponent } from './MSSIDC/eventdetail/eventdetail.component';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogModule } from '@angular/material/dialog';  
import { dicDashboardComponent } from './DIC/dashboard/dicdashboard.component';
//import { Observable } from 'rxjs';

import { FullCalenderComponent } from '../../../core/components/full-calender/full-calender.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { IaeventcompletionComponent } from './IA/iaeventcompletion/iaeventcompletion.component';
import { IaeventmarkattendanceComponent } from './IA/iaeventmarkattendance/iaeventmarkattendance.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { OnspotregistrationComponent } from './IA/onspotregistration/onspotregistration.component';
import { ViewallonspotregistrationComponent } from './IA/viewallonspotregistration/viewallonspotregistration.component';
import { NgbModule, NgbPagination, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SubmitgrievanceComponent } from './MSME/submitgrievance/submitgrievance.component';
import { EventreportComponent } from './IA/eventreport/eventreport.component';
import { MatNativeDateModule } from '@angular/material/core';
import { GrievancedashboardmssidcComponent } from './MSSIDC/grievancedashboardmssidc/grievancedashboardmssidc.component';
import { GrievancedashboardiaComponent } from './IA/grievancedashboardia/grievancedashboardia.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ViewandreplygrievanceComponent } from './MSSIDC/viewandreplygrievance/viewandreplygrievance.component';
import { MsmeotherdetailsComponent } from './MSSIDC/msmeotherdetails/msmeotherdetails.component';
import { ViewiadetailsComponent } from './MSSIDC/viewiadetails/viewiadetails.component';
import { ViewandreplygrievancebyiaComponent } from './IA/viewandreplygrievancebyia/viewandreplygrievancebyia.component';
import { GrievancedashboardComponent } from './MSME/grievancedashboard/grievancedashboard.component';
import { ViewgrievancereplyComponent } from './MSME/viewgrievancereply/viewgrievancereply.component';
import { ReversebuyersellerComponent } from './IA/reversebuyerseller/reversebuyerseller.component';
import { RepositorycontentComponent } from './IA/repositorycontent/repositorycontent.component';
import { ReversebuyerrequirementComponent } from './IA/reversebuyerrequirement/reversebuyerrequirement.component';
import { InvoicedashboardiaComponent } from './IA/invoicedashboardia/invoicedashboardia.component';
import { InvoicedashboardmssidcComponent } from './MSSIDC/invoicedashboardmssidc/invoicedashboardmssidc.component';
import { GradingComponent } from './MSSIDC/grading/grading.component';
import { InvoicecalculationComponent } from './IA/invoicecalculation/invoicecalculation.component';
import { FeedbackQuestionComponent } from './MSSIDC/feedback-question/feedback-question.component';
import { MatChipsModule } from '@angular/material/chips'; // Import MatChipModule
import { CustomfeedbackComponent } from './MSSIDC/customfeedback/customfeedback.component';
import { MsmerepositorycontentComponent } from './MSME/msmerepositorycontent/msmerepositorycontent.component';
import { MsmecustomfeedbackComponent } from './MSME/msmecustomfeedback/msmecustomfeedback.component'; // Import MatChipModule
import { ViewinvoicedetailsComponent } from './MSSIDC/viewinvoicedetails/viewinvoicedetails.component';
import { UpdatepaymentdetailsComponent } from './MSSIDC/updatepaymentdetails/updatepaymentdetails.component';

import { ViewallonspotusersComponent } from './IA/viewallonspotusers/viewallonspotusers.component';
import { VieweventdocumentsComponent } from './IA/vieweventdocuments/vieweventdocuments.component';
import { ViewmsmedocumentsComponent } from './MSSIDC/viewmsmedocuments/viewmsmedocuments.component';
import { VerifyonspotmsmeComponent } from './IA/verifyonspotmsme/verifyonspotmsme.component';
import { VeiwenrolledmsmeComponent } from './IA/veiwenrolledmsme/veiwenrolledmsme.component';
import { ViewregistermsmebyiainterestComponent } from './IA/viewregistermsmebyiainterest/viewregistermsmebyiainterest.component';
import { ViewEnrolledMSMEComponent } from './MSSIDC/view-enrolled-msme/view-enrolled-msme.component';
import { ViewattendedmsmeComponent } from './IA/viewattendedmsme/viewattendedmsme.component';
import { CompletedinvoicelistComponent } from '../admin/report/completedinvoicelist/completedinvoicelist.component';
import { IaproposalworkorderstatusComponent } from './iaproposalworkorderstatus/iaproposalworkorderstatus.component';
import { DownloadcertificateComponent } from './IA/downloadcertificate/downloadcertificate.component';
import { EventfeedbacklistComponent } from './IA/eventfeedbacklist/eventfeedbacklist.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { UsernmanualComponent } from './usernmanual/usernmanual.component';
import { EoiinvitationComponent } from './eoiinvitation/eoiinvitation.component';
import { EoiverificationofmsmeComponent } from './eoiverificationofmsme/eoiverificationofmsme.component';
import { EoiotpverificationComponent } from './eoiotpverification/eoiotpverification.component';
import { EoiComponent } from './eoi/eoi.component';

import { MatExpansionModule } from '@angular/material/expansion';
import { EoiListComponent } from './MSSIDC/eoi-list/eoi-list.component';
import { EoiViewComponent } from './MSSIDC/eoi-view/eoi-view.component';
import { EoipdfComponent } from './eoipdf/eoipdf.component';
import { EOIExhibitionComponent } from './eoi-exhibition/eoi-exhibition.component';
import { EoiExhibitionViewComponent } from './MSSIDC/eoi-exhibition-view/eoi-exhibition-view.component';
import { EoiExhibitionListComponent } from './MSSIDC/eoi-exhibition-list/eoi-exhibition-list.component';
import { EoiExhibitionFileViewerComponent } from './MSSIDC/eoi-exhibition-file-viewer/eoi-exhibition-file-viewer.component';
import { ExcelListComponent } from './MSSIDC/excel-list/excel-list.component';
import { UpdateEventDateComponent } from './MSSIDC/update-event-date/update-event-date.component';
import { UpdateEventDatePopupComponent } from './MSSIDC/update-event-date-popup/update-event-date-popup.component';
import { UpdateEventDateListComponent } from './MSSIDC/update-event-date-list/update-event-date-list.component';
import { EventDateHistoryPopupComponent } from './MSSIDC/event-date-history-popup/event-date-history-popup.component';
import { UpdateMsmeAttendanceListComponent } from './MSSIDC/update-msme-attendance-list/update-msme-attendance-list.component';
import { UpdateMsmeAttendanceComponent } from './MSSIDC/update-msme-attendance/update-msme-attendance.component';
import { UpdateMsmeAttendancePopupComponent } from './MSSIDC/update-msme-attendance-popup/update-msme-attendance-popup.component';
import { UpdateMsmeAttendanceAuditComponent } from './MSSIDC/update-msme-attendance-audit/update-msme-attendance-audit.component';
import { UpdateUploadDocumentsListComponent } from './MSSIDC/update-upload-documents-list/update-upload-documents-list.component';
import { UpdateUploadDocumentsComponent } from './MSSIDC/update-upload-documents/update-upload-documents.component';
import { UpdateUploadDocumentsPopupComponent } from './MSSIDC/update-upload-documents-popup/update-upload-documents-popup.component';
import { UpdateUploadDocumentsFormComponent } from './MSSIDC/update-upload-documents-form/update-upload-documents-form.component';
import { UpdateDocumentHistoryPopupComponent } from './MSSIDC/update-document-history-popup/update-document-history-popup.component';
import { UpdateLoginBannerComponent } from './MSSIDC/update-login-banner/update-login-banner.component';
import { AddupdatebannerpopupComponent } from './MSSIDC/addupdatebannerpopup/addupdatebannerpopup.component';





@NgModule({
  declarations: [
    //DashboardComponent,
    
    ChangepasswordComponent,
    RegisterComponent,
    MSMEUSERVERIFICATIONComponent,
    RegisteruserasComponent,
    ContactdetailsComponent,
    CredentialdetailsComponent,
    MsmepreviewpageComponent,
    PersonaldetailsComponent,
    IAregisterComponent,
    IapreviewpageComponent,
    ForgotpasswordComponent,
    IaproposalpageComponent,
    IasubmitnewproposalComponent,
    MssidcproposalpageComponent,
    MssidcverifyproposalComponent,
    IaproposalpageComponent,
    IasubmitnewproposalComponent,
    VerifymsmeComponent,
    VerifyMSMEDetailsComponent,
    VerifyMSMEViewComponent,
    HeaderComponent,
    FooterComponent,
    OtheruserdetailsComponent,
    CreatenewproposalComponent,
    CreatenewproposalComponent,
    IaeventcreateComponent,
    LayoutComponent,
    DashboardComponent,
    LeftcolComponent,
    IaprofileComponent,
    PaginationComponent,
    ProposalComponent,
    ProfileComponent,
    EnrollneweventComponent,
    VieweventsComponent,
    IaquestionanswerComponent,
    FeedbackformComponent,
    ViewflattedgalaComponent,
    ViewgrievancesdashboardComponent,
    VieweventdetailsComponent,
    DownloadticketComponent,
    VerifyProposalComponent,
    TrimInputValueDirective,
    VerifyProposalDetailsComponent,
    VieweventComponent,
    EventdetailComponent,
    dicDashboardComponent,
    FullCalenderComponent,
    IaeventcompletionComponent,
    IaeventmarkattendanceComponent,
    ConfirmationDialogComponent,
    OnspotregistrationComponent,
    ViewallonspotregistrationComponent,
    SubmitgrievanceComponent,
    MsmeotherdetailsComponent,
    ViewiadetailsComponent,
    SubmitgrievanceComponent,
    EventreportComponent,
    GrievancedashboardComponent,
    GrievancedashboardiaComponent,
    GrievancedashboardmssidcComponent,
    ViewandreplygrievanceComponent,
    ViewandreplygrievancebyiaComponent,
    ViewgrievancereplyComponent,
    ReversebuyersellerComponent,
    ReversebuyerrequirementComponent,
    RepositorycontentComponent,
    FeedbackQuestionComponent,
    CustomfeedbackComponent,
    InvoicedashboardiaComponent,
    InvoicedashboardmssidcComponent,
    InvoicecalculationComponent,
    GradingComponent,
    MsmerepositorycontentComponent,
    MsmecustomfeedbackComponent,
    ViewinvoicedetailsComponent,
    UpdatepaymentdetailsComponent, 
    ViewallonspotusersComponent, 
    VieweventdocumentsComponent,
    ViewmsmedocumentsComponent,
    VerifyonspotmsmeComponent,
    ViewregistermsmebyiainterestComponent,
    VerifyonspotmsmeComponent,
    VeiwenrolledmsmeComponent,
    ViewEnrolledMSMEComponent,
    ViewattendedmsmeComponent,
    CompletedinvoicelistComponent,
    IaproposalworkorderstatusComponent,
    DownloadcertificateComponent,
    EventfeedbacklistComponent,
    UsernmanualComponent,
    EoiinvitationComponent,
    EoiverificationofmsmeComponent,
    EoiotpverificationComponent,
    EoiComponent,
    EoiListComponent,
    EoiViewComponent,
    EoipdfComponent,
    EOIExhibitionComponent,
    EoiExhibitionViewComponent,
    EoiExhibitionListComponent,
    EoiExhibitionFileViewerComponent,
    ExcelListComponent,
    UpdateEventDateComponent,
    UpdateEventDatePopupComponent,
    UpdateEventDateListComponent,
    EventDateHistoryPopupComponent,
UpdateMsmeAttendanceListComponent,
UpdateMsmeAttendanceComponent,
    UpdateMsmeAttendancePopupComponent,
    UpdateMsmeAttendanceAuditComponent,
    UpdateUploadDocumentsListComponent,
    UpdateUploadDocumentsComponent,
    UpdateUploadDocumentsPopupComponent,
    UpdateUploadDocumentsFormComponent,
    UpdateDocumentHistoryPopupComponent,
    // UpdateLoginBannerComponent,
     AddupdatebannerpopupComponent

  ],
  
  imports: [
    CommonModule,
    WebsiteRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    MatInputModule,
    MatCardModule,
    MatCardActions,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatFormFieldModule,
    MatPaginator,
    MatPaginatorModule,     
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatCheckboxModule,
    NgSelectModule,
    MatTabsModule,
    MatIconModule,
    MatDialogModule,
    FullCalendarModule,
    MatDatepickerModule,
    NgbModule,   
    NgbPaginationModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    MatChipsModule,
    MatTooltipModule,
    MatToolbarModule,
    MatExpansionModule,
   /* NgxMaterialTimepickerModule,*/
    NgMultiSelectDropDownModule.forRoot()
    /*ReactiveFormsModule,*/,
    MatIconModule,
    
    
  ]
})
export class WebsiteModule { }
